module.exports = __webpack_public_path__ + "static/media/Seven-Great-Things-To-Use-Cash-For-Cars.ffb6c148.jpg";